import { createFileRoute } from "@tanstack/react-router";
import { NextUpPage } from "@/components/planning/nextup/NextUpPage";

export const Route = createFileRoute("/_app/p/$productKey/next-up")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  return <NextUpPage productKey={productKey} />;
}
